// JST 表示用ヘルパ。API は ISO 文字列を返すので Date(...) → 表示用にフォーマット。

const JST_OFFSET_MS = 9 * 60 * 60 * 1000;

export function todayYmdJst(): string {
  const now = new Date();
  const jst = new Date(now.getTime() + JST_OFFSET_MS);
  return jst.toISOString().slice(0, 10);
}

export function addDaysYmdJst(ymd: string, days: number): string {
  const [y, m, d] = ymd.split("-").map(Number);
  const date = new Date(Date.UTC(y!, (m ?? 1) - 1, d ?? 1));
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function formatYmdLabel(ymd: string): string {
  const [y, m, d] = ymd.split("-");
  return `${y}年${Number(m)}月${Number(d)}日`;
}

export function formatYmdShort(ymd: string): string {
  const [, m, d] = ymd.split("-");
  return `${Number(m)}/${Number(d)}`;
}

export function formatJstDateTime(iso: string): string {
  const d = new Date(iso);
  const jst = new Date(d.getTime() + JST_OFFSET_MS);
  const y = jst.getUTCFullYear();
  const mm = jst.getUTCMonth() + 1;
  const dd = jst.getUTCDate();
  const hh = String(jst.getUTCHours()).padStart(2, "0");
  const mi = String(jst.getUTCMinutes()).padStart(2, "0");
  return `${y}年${mm}月${dd}日 ${hh}:${mi}`;
}

export function jstWeekdayLabel(ymd: string): string {
  const [y, m, d] = ymd.split("-").map(Number);
  const date = new Date(Date.UTC(y!, (m ?? 1) - 1, d ?? 1, 0, 0, 0));
  const w = date.getUTCDay();
  return ["日", "月", "火", "水", "木", "金", "土"][w] ?? "";
}

export function buildReservedAtIso(ymd: string, hhmm: string): string {
  const [hh, mm] = hhmm.split(":").map(Number);
  const [y, m, d] = ymd.split("-").map(Number);
  const utcMs = Date.UTC(y!, (m ?? 1) - 1, d ?? 1, hh ?? 0, mm ?? 0) - JST_OFFSET_MS;
  return new Date(utcMs).toISOString();
}
